import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Header } from '../../shared/model/header.model';
import { Section } from '../../shared/model/section.model';
import { Signature } from '../../shared/model/sign.model';

@Component({
    selector: 'app-document-preview',
    templateUrl: './document-preview.component.html',
    styleUrls: ['./document-preview.component.scss'],
    standalone: false
})
export class DocumentPreviewComponent implements OnInit {

  @Input()
  documentSections: Section[][]
  @Input()
  headerContent: Header
  @Input()
  signatures: Signature[]
  @Input()
  signatureStyle: any = {}

  constructor(
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
  }
}
